import { CheveronDownIcon } from '@wkda/icons';
import cx from 'classnames';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function VerticalNavMenu(_ref) {
  let {
    navList,
    LinkComponent = 'a',
    className,
    ...spreadProps
  } = _ref;
  const [openedIndexes, setOpenedIndexes] = useState(null);
  function toggleDropDown(itemIndex) {
    setOpenedIndexes(prevIndex => {
      if (prevIndex === itemIndex) {
        return null;
      }
      return itemIndex;
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: cx('wa-nav-vertical', className),
    ...spreadProps,
    children: /*#__PURE__*/_jsx("ul", {
      className: "wa-nav-vertical__list",
      children: navList.map((item, index) => {
        const itemHasDropdowns = item?.dropDowns != null && item.dropDowns.length > 0;
        const isOpened = openedIndexes === index;
        return /*#__PURE__*/_jsxs("li", {
          className: cx('wa-nav-vertical__item', {
            'wa-accordeon__container': itemHasDropdowns,
            'wa-accordeon--is-open': isOpened
          }),
          children: [!itemHasDropdowns ? /*#__PURE__*/_jsxs(LinkComponent, {
            className: "wa-nav-vertical__item-link",
            href: item.link,
            children: [item.icon && /*#__PURE__*/_jsx("span", {
              className: "wa-nav-vertical__item-link-icon",
              children: item.icon
            }), item.title ? /*#__PURE__*/_jsx(ItemTitle, {
              ...item
            }) : null]
          }) : /*#__PURE__*/_jsxs("div", {
            onClick: () => toggleDropDown(index),
            className: cx('wa-nav-vertical__item-button', {
              'wa-nav-vertical__item-button--open': isOpened
            }),
            children: [item.title ? /*#__PURE__*/_jsx(ItemTitle, {
              ...item
            }) : null, /*#__PURE__*/_jsx(CheveronDownIcon, {
              className: cx('wa-nav__chevron', {
                'wa-nav-vertical__chevron--is-open': isOpened
              })
            })]
          }), itemHasDropdowns ? /*#__PURE__*/_jsx("div", {
            className: "wa-accordeon__content",
            children: (item.dropDowns ?? []).map(function renderDropdowns(dropDown, key) {
              return /*#__PURE__*/_jsx(NavSubList, {
                LinkComponent: LinkComponent,
                dropdown: dropDown
              }, key);
            })
          }) : null]
        }, index);
      })
    })
  });
}
function NavSubList(_ref2) {
  let {
    dropdown,
    LinkComponent
  } = _ref2;
  const listTitle = dropdown.title ? /*#__PURE__*/_jsx(ItemTitle, {
    ...dropdown
  }) : null;
  return /*#__PURE__*/_jsxs("ul", {
    className: "wa-nav-vertical__sublist",
    children: [listTitle && /*#__PURE__*/_jsx("li", {
      className: "wa-nav-vertical__sublist-title",
      children: listTitle
    }), dropdown.items.map((item, key) => /*#__PURE__*/_jsx("li", {
      className: "wa-nav-vertical__subitem",
      children: /*#__PURE__*/_jsx(LinkComponent, {
        className: "wa-nav-vertical__subitem-link",
        href: item.link,
        children: item.title ? /*#__PURE__*/_jsx(ItemTitle, {
          ...item
        }) : null
      })
    }, key))]
  });
}
export function ItemTitle(_ref3) {
  let {
    title,
    mobileTitle
  } = _ref3;
  return mobileTitle ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "header-item-title",
      children: title
    }), /*#__PURE__*/_jsx("span", {
      className: "header-item-title-mobile",
      children: mobileTitle
    })]
  }) : title ? /*#__PURE__*/_jsx(_Fragment, {
    children: title
  }) : null;
}